import EnumSelect from "../../../common/EnumSelect";
import {
  CustomFieldInputComponent,
  CustomFieldValue,
} from "../CustomFieldsForm";

enum BooleanSelectValue {
  YES = "YES",
  NO = "NO",
  UNSET = "UNSET",
}

const booleanSelectValueToBoolean = (value: BooleanSelectValue) => {
  switch (value) {
    case BooleanSelectValue.YES:
      return true;
    case BooleanSelectValue.NO:
      return false;
    case BooleanSelectValue.UNSET:
      return null;
  }
};

const customFieldValueToBooleanSelectValue = (
  value: CustomFieldValue | null
): BooleanSelectValue => {
  if (value === true) {
    return BooleanSelectValue.YES;
  }
  if (value === false) {
    return BooleanSelectValue.NO;
  }
  return BooleanSelectValue.UNSET;
};

const BooleanCustomFieldInput: CustomFieldInputComponent = ({
  value,
  customFieldDefinition,
  onChange,
  disabled,
}) => {
  return (
    <EnumSelect data-testid="boolean-custom-field-input-boolean-select-value"
      label={customFieldDefinition.label}
      enumObject={BooleanSelectValue}
      value={customFieldValueToBooleanSelectValue(value)}
      disabled={disabled}
      onChange={(e, value) => {
        if (value === null) {
          onChange(null);
          return;
        }
        onChange(booleanSelectValueToBoolean(value));
      }}
      optionLabel={(value) => {
        switch (value) {
          case BooleanSelectValue.YES:
            return "Yes";
          case BooleanSelectValue.NO:
            return "No";
          case BooleanSelectValue.UNSET:
            return "Unset";
        }

        return value;
      }}
    />
  );
};

export default BooleanCustomFieldInput;
